import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExposureAgentsService {


  private agentsSubject = new BehaviorSubject([]);
  agents = this.agentsSubject.asObservable();


  updateAgents(array: any[]): void{
    this.agentsSubject.next(array);
  }

  constructor() { }


}
